import React, { useEffect, useState } from "react";
import { Button, Card, Spin, Tag, Typography, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { ServiceSelectionService } from "../services/ServiceSelectionService";
import { Service } from "../models/Service";

const { Title, Text } = Typography;

const ServiceSelectionPage: React.FC = () => {
    const navigate = useNavigate();

    const [selected, setSelected] = useState<Service | null>(null);
    const [services, setServices] = useState<Service[]>([]);
    const [loading,  setLoading]  = useState(true);

    useEffect(() => {
        ServiceSelectionService.getAllServices()
            .then((data: Service[]) => {
                const sorted = [...data].sort((a, b) => Number(b.is_active) - Number(a.is_active));
                setServices(sorted);
            })
            .finally(() => setLoading(false));
    }, []);

    const handleContinue = () => {
        if (!selected) return;
        ServiceSelectionService.setSelectedServices(selected).finally(() => setLoading(false));
        navigate("/home");
    };

    return (
        <Flex align="center" justify="center" style={{ minHeight: "100vh", background: "#F7F9FC" }}>
            <Flex vertical style={{ width: "100%", maxWidth: 480, padding: 24 }} gap="large">

                {/* Header */}
                <Flex vertical align="center" gap="small">
                    <Title level={3} style={{ margin: 0 }}>What do you need?</Title>
                    <Text type="secondary">Choose a service to get started</Text>
                </Flex>

                {/* Loading */}
                {loading ? (
                    <Flex vertical align="center" gap="small" style={{ padding: "48px 0" }}>
                        <Spin size="large" />
                        <Text type="secondary">Loading services…</Text>
                    </Flex>
                ) : (
                    <Flex vertical gap="small">
                        {/* Service cards */}
                        {services.map((service) => (
                            <Card
                                key={service.id}
                                onClick={() => service.is_active && setSelected(service)}
                                style={{ opacity: service.is_active ? 1 : 0.45, cursor: service.is_active ? "pointer" : "default" }}
                                styles={{ body: { padding: "16px 20px" } }}
                                variant={selected === service ? "borderless" : "outlined"}
                            >
                                <Flex justify="space-between" align="center">
                                    <Flex vertical gap={4}>
                                        <Text strong style={{ fontSize: 16 }}>{service.name}</Text>
                                        <Tag color={service.is_active ? "success" : "error"} style={{ width: "fit-content" }}>
                                            {service.is_active ? "Available" : "Not available"}
                                        </Tag>
                                    </Flex>
                                </Flex>
                            </Card>
                        ))}

                        {/* Continue */}
                        <Button
                            type="primary"
                            size="large"
                            block
                            shape="round"
                            disabled={!selected}
                            onClick={handleContinue}
                        >
                            {selected ? `Continue with ${selected.name} →` : "Select a service"}
                        </Button>
                    </Flex>
                )}

            </Flex>
        </Flex>
    );
};

export default ServiceSelectionPage;